import * as z from 'zod';

import { nullableNumericQuerySchema } from '@/_schemas/generic';

export const inventoryQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
  current_stock: nullableNumericQuerySchema(),
  primary_sku: z.string().nullable(),
});

export type InventoryQueryLinkerSchema = z.infer<typeof inventoryQueryLinkerSchema>;
